export enum FlowDesignerViewTab {
  Assets,
  Events,
  Communications,
  Extras,
}
